import { useState } from 'react';
import './ContactCTA.css';

const MESSAGES_KEY = 'LathiNyx_messages';

function saveMessage(msg) {
  try {
    const existing = JSON.parse(localStorage.getItem(MESSAGES_KEY)) || [];
    localStorage.setItem(MESSAGES_KEY, JSON.stringify([{ ...msg, id: Date.now().toString(36), receivedAt: new Date().toLocaleString('en-IN') }, ...existing]));
  } catch {}
}

export default function ContactCTA() {
  const [form, setForm] = useState({ name: '', email: '', service: 'Web Development', budget: 'Not Sure Yet', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      alert('Please fill in your name, email, and message.');
      return;
    }
    saveMessage(form);
    setSent(true);
    setForm({ name: '', email: '', service: 'Web Development', budget: 'Not Sure Yet', message: '' });
    setTimeout(() => setSent(false), 4000);
  };
  return (
    <section className="contact-cta-section" id="contact">
      <div className="container">
        <div className="cta-top">
          <div className="cta-top-text">
            <h2 className="cta-heading">Ready to Start Your Project?</h2>
            <p className="cta-sub">Get a free consultation and custom quote within 24 hours. No commitment required.</p>
          </div>
        </div>

        <div className="cta-content-grid">
          <div className="cta-info">
            <h3>Let's Build Something Great Together</h3>
            <p>
              Whether you need a professional website, a custom AI solution, or expert research paper support, LathiNyx DevLabs™ is ready to help. We have worked with 10+ clients across India and internationally, delivering 10+ successful projects with a 4.9-star average rating.
            </p>
            <p>
              Our process is simple: reach out, we discuss your requirements, we send a proposal within 24 hours, and once approved, we get to work immediately. Most projects begin within 48 hours of agreement.
            </p>
            <p>
              We offer flexible payment terms, transparent pricing, and a satisfaction guarantee. If you are not happy with the work, we revise it until you are — no questions asked.
            </p>

            <div className="cta-contact-details">
              <div className="cta-contact-item">
                <span className="cta-contact-icon">📧</span>
                <div>
                  <div className="cta-contact-label">Email Us</div>
                  <a href="mailto:lathinyxdevlabs@gmail.com" className="cta-contact-val">lathinyxdevlabs@gmail.com</a>
                </div>
              </div>
              <div className="cta-contact-item">
                <span className="cta-contact-icon">🌐</span>
                <div>
                  <div className="cta-contact-label">Website</div>
                  <a href="https://lathinyxdevlabs.com" className="cta-contact-val">lathinyxdevlabs.com</a>
                </div>
              </div>
              <div className="cta-contact-item">
                <span className="cta-contact-icon">📍</span>
                <div>
                  <div className="cta-contact-label">Location</div>
                  <span className="cta-contact-val">Patna, Bihar, India</span>
                </div>
              </div>
            </div>
          </div>

          <div className="cta-form-wrap">
            <div className="cta-form-card">
              <h3>Send Us a Message</h3>
              <p>Fill in the form and we will get back to you within 24 hours.</p>
              <div className="cta-form">
                <div className="cta-form-row">
                  <div className="cta-fg">
                    <label>Your Name</label>
                    <input type="text" placeholder="e.g. Rahul Sharma" value={form.name} onChange={e => setForm(p => ({...p, name: e.target.value}))} />
                  </div>
                  <div className="cta-fg">
                    <label>Email Address</label>
                    <input type="email" placeholder="your@email.com" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} />
                  </div>
                </div>
                <div className="cta-fg">
                  <label>Service Required</label>
                  <select value={form.service} onChange={e => setForm(p => ({...p, service: e.target.value}))}>
                    <option>Web Development</option>
                    <option>AI & ML Solutions</option>
                    <option>Research Paper Services</option>
                    <option>Multiple Services</option>
                    <option>Other / Not Sure</option>
                  </select>
                </div>
                <div className="cta-fg">
                  <label>Budget Range</label>
                  <select value={form.budget} onChange={e => setForm(p => ({...p, budget: e.target.value}))}>
                    <option>Under Rs.10,000</option>
                    <option>Rs.10,000 – Rs.30,000</option>
                    <option>Rs.30,000 – Rs.1,00,000</option>
                    <option>Rs.1,00,000+</option>
                    <option>Not Sure Yet</option>
                  </select>
                </div>
                <div className="cta-fg">
                  <label>Tell Us About Your Project</label>
                  <textarea rows={4} placeholder="Describe your project, requirements, and any specific details..." value={form.message} onChange={e => setForm(p => ({...p, message: e.target.value}))}></textarea>
                </div>
                {sent ? (
                  <div style={{ background: '#edfaf4', color: '#1a7a52', padding: '12px 16px', borderRadius: 8, fontWeight: 600, fontSize: 14 }}>
                    ✅ Message sent! We'll get back to you within 24 hours.
                  </div>
                ) : (
                  <button className="cta-submit-btn" onClick={handleSubmit}>
                    Send Message →
                  </button>
                )}
                <p className="cta-form-note">We respond within 24 hours. Your information is kept strictly confidential.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
